export default [
  {
    name: 'plugin',
    definition: {
      name: '',
      base_url: '',
      configuration: {},
      plugin_slots: []
    },
    options: {
      type: 'plugin'
    }
  }
]
